export enum ProgramType {
  PRO = "PRO",
  CORE = "CORE",
  WTW_ENGAGE = "WTW_ENGAGE"
}

export type Journey = {
  isAppSupportEnabled: boolean
  hasEligibleExpenses: boolean
}

export enum CarrotRxPharmacyType {
  ALTO = "ALTO",
  FREEDOM_FERTILITY = "FREEDOM_FERTILITY"
}

export type Benefit = {
  program: {
    type: ProgramType
    isCarrotLite: boolean
  }
  journeys: {
    fertilityCare: Journey & {
      eligibleExpensesDetail: {
        isCoveredWithInfertilityDiagnosis: boolean
        infertilityEligibleExpensesDetail: {
          hasInsuranceCoverageForQmes: boolean
          canUseCarrotFundsAfterInsuranceExhausted: boolean
        }
        isElectiveCareCovered: boolean
        ivfRequirementsApply: boolean
        hasDonorAssistance: boolean
        areTravelCostsForTerminationCovered: boolean
        isRxCovered: boolean
        obGynProvidedFertilityCareCovered: boolean
      }
      isMiraEnabled: boolean
    }
    fertilityPreservation: Journey & {
      eligibleExpensesDetail: {
        isMedicallyNecessaryPreservationCovered: boolean
        medicallyNecessaryPreservationDetails: {
          hasInsuranceCoverageForQmes: boolean
          canUseCarrotFundsAfterInsuranceExhausted: boolean
        }
        isElectivePreservationCovered: boolean
        isRxCovered: boolean
      }
    }
    adoption: Journey
    gestationalCarrier: Journey & {
      eligibleExpensesDetail: {
        medicalAndAncillaryServicesCovered: boolean
        legalAndAgencyServicesCovered: boolean
        isRxCovered: boolean
      }
    }
    pregnancy: Journey & {
      eligibleExpensesDetail: {
        doulaExpensesCovered: boolean
        additionalPregnancyExpensesCovered: boolean
        milkShippingCovered: boolean
        childbirthClassesCovered: boolean
      }
    }
    parenting: Journey
    menopause: Journey
    lowTestosterone: Journey
    genderAffirmingCare: Journey
  }
  carrotRx: {
    isCarrotRxActive: boolean
    isCarrotRxRequired: boolean
    defaultPharmacy: CarrotRxPharmacyType | null
    fertilityPharmacy: CarrotRxPharmacyType | null
  }
  providerFinder: {
    showProviderFinder: boolean
    showFertilityClinics: boolean
    showReproductiveUrology: boolean
    showCryobanks: boolean
    showAdoption: boolean
    showDonorAssistance: boolean
    showGestationalSurrogacy: boolean
    showMenopause: boolean
    showLowTestosterone: boolean
    showGenderAffirmingHormoneTherapy: boolean
    showFertilityWrapAroundMessage: boolean
    showPediatricianRecommendations: boolean
    showObGynRecommendations: boolean
    showDoulas: boolean
  }
  customizations: {
    additionalEmployerBenefitMarkdown: string
    memberCustomCoverageExplanationMarkdown: string
    healthPlanMarkdown: string
  }
  generalSupport: {
    showLgbtqContent: boolean
    showDonorContent: boolean
    faithInformedCareEnabled: boolean
    showPartnerContent: boolean
  }
  supportCenter: {
    enabled: boolean
  }
  telemedicine: {
    hasAvailableProviders: boolean
    providers: {
      wheelForMenopauseEnabled: boolean
      blueberryPediatricsEnabled: boolean
    }
  }
  partnerEligibility: {
    isEligibleForCoverage: boolean
    limitations: {
      mustBeOnCompanyMedicalPlan: boolean
      mustBeLegalPartner: boolean
    }
  }
  partnerAccess: {
    allowPartnerCredentials: boolean
  }
  calibratedEngagement: {
    enabled: boolean
  }
  sprints: {
    enabled: boolean
    fertilityCare: {
      enabled: boolean
      telemedicine: {
        enabled: boolean
        hasEligibleExpenses: boolean
      }
    }
  }
}
